import { render } from "./ShowClientInfo.vue?vue&type=template&id=29f6b871&scoped=true"
import script from "./ShowClientInfo.vue?vue&type=script&lang=js"
export * from "./ShowClientInfo.vue?vue&type=script&lang=js"

import "./ShowClientInfo.vue?vue&type=style&index=0&id=29f6b871&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f6b871"]])

export default __exports__